module.exports = __webpack_public_path__ + "static/media/mehandi.10a923f0.jpeg";